jQuery.feature_import("js-stored-query",
  () => require("./stored-query.js"),
  mod => mod.feature_js_stored_query
);
jQuery.feature_import("js-stored-query-form",
  () => require("./stored-query.js"),
  mod => mod.feature_js_stored_query_form
);
